import { ChangeDetectorRef, Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { getCurrentTab, SettingChildTab, SettingTabList } from './setting.const';
import { BaseComponent } from '../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  moduleId: module.id,
  selector: 'settings',
  templateUrl: './settings.component.html',
  styleUrls: ['../../../../../css/fuck.css', './settings.css'],
  providers: [],
})
@Injectable()
export class SettingsComponent extends BaseComponent {
  public currentTab = '';
  public settingTabList = SettingTabList;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private router: Router
  ) {
    super(changeDetector, toastr, modalService);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
    const tabAdmin = {
      id: SettingChildTab.Account,
      title: 'Tenant',
    };
    const tabMultiChanel = {
      id: SettingChildTab.Conversation,
      title: 'Thiết lập đa kênh',
    };
    const tabOther = {
      id: SettingChildTab.Other,
      title: 'Khác',
    };
    if (this.user.tenant_id !== '66189e79e886834debac75d5') {
      this.settingTabList = [tabMultiChanel, ...this.settingTabList, tabOther];
    } else {
      this.currentTab = SettingChildTab.Expert;
    }
    if (this.user.admin) {
      this.settingTabList = [...this.settingTabList, tabAdmin];
    }
  }

  onChangeTab(tabId: SettingChildTab) {
    this.currentTab = tabId;
    this.router.navigate([tabId]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/settings.component.ts